// Module
var code = "<svg viewBox=\"0 0 14 10\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M9 0.999542L13 5.01442L9 9.0293\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path d=\"M13 5.01367L1 5.01367\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;